import { z } from "zod";

export const formalityReq = z.object({
  reassignedDue: z.string().min(1, "Selecciona una razón"),
  comment: z.string().max(120, "Máximo 120 caracteres").optional(),
});
